module.exports = __webpack_public_path__ + "img/icon2.839f6b6f.png";